// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ModulesCarousel_carousel__3-JGt","topSpan":"ModulesCarousel_topSpan__3Ty2f","topSpanLeft":"ModulesCarousel_topSpanLeft__2dYv0"};